import http from '@/biz/http.mjs'
import {useChoosePromptTemplate} from '@/biz/promptTemplate.jsx'
import {Confirm, useOpenModal} from '@/components/Modal/index.mjs'
import openWindow from '@/script/openWindow.mjs'
import runAsync from '@/script/runAsync.mjs'

export const useRunWorkflow = () => {
    const openModal = useOpenModal()
    const chooseTemplate = useChoosePromptTemplate()

    return async ({bizMap, scene}) => {
        const template = await chooseTemplate(scene, bizMap.prjId)

        if (! template) {
            return
        }

        const {
            llmId,
            pkid: promptTemplateId,
            promptTemplateCode,
            promptTemplateResponseMode,
            usageScenarioCode,
        } = template

        const steps = template.llmPromptTemplateItems.map(
            ({
                itemCode,
                itemName,
                pkid,
                systemMessageTemplate,
                toolMessageTemplate,
                userMessageTemplate,
                ...e
            }) => ({
                ...e,
                stepCode: itemCode,
                stepId: pkid,
                stepName: itemName,
                systemMessage: systemMessageTemplate,
                userMessage: userMessageTemplate,
            })
        )

        const {reentry, workflowInstanceId} = await runAsync(
            () => http.post(
                '/ai/execute',

                {
                    bizMap,
                    llmId,
                    steps,
                    usageScenarioCode,
                    workflowCode: promptTemplateCode,
                    workflowId: promptTemplateId,
                    workflowResponseMode: promptTemplateResponseMode,
                },
            ),

            {action: '执行AI助手'}
        )

        if (reentry) {
            const isConfirmed = await openModal(
                <Confirm
                    cancelText="否"
                    okText="是"
                >
                    上一个AI助手还在执行中(请勿重复执行)，是否进入AI助手详情页？
                </Confirm>
            )

            if (! isConfirmed) {
                return
            }
        }

        openWindow('/WorkflowInstance', {workflowInstanceId})
    }
}
